import {
  NetworkGroup,
  ResourceType,
} from '@energybox/react-ui-library/dist/types';
import * as R from 'ramda';
import { Actions } from '../actions/networkGroups';

export interface NetworkGroups {
  networkGroupsById: { [id: string]: NetworkGroup };
  isGetNetworkGroupLoading: boolean;
}

export const NetworkGroupsFromApiResponse = (data: any) => ({
  id: data.id,
  title: data.title,
  description: data.description,
  createdAt: data.createdAt,
  updatedAt: data.updatedAt || undefined,
  edge: data.edge || {},
  resourceType: ResourceType[(data._entity as string).toUpperCase()],
  siteId: data.siteId,
});

const initialState = {
  networkGroupsById: {},
  isGetNetworkGroupLoading: false,
};

const networkGroups = (state: NetworkGroups = initialState, action: any) => {
  switch (action.type) {
    case Actions.GET_NETWORK_GROUP_SUCCESS:
      let networkGroup = NetworkGroupsFromApiResponse(action.payload);

      return R.pipe(
        R.assocPath(['networkGroupsById', action.payload.id], networkGroup),
        R.assoc('isGetNetworkGroupLoading', false)
      )(state);

    case Actions.GET_NETWORK_GROUP_LOADING:
      return R.pipe(R.assoc('isGetNetworkGroupLoading', true))(state);

    case Actions.GET_NETWORK_GROUP_ERROR:
      return R.pipe(R.assoc('isGetNetworkGroupLoading', false))(state);

    default:
      return state;
  }
};

export default networkGroups;
